import { CAvatar } from './CAvatar.js';

const CAvatarPlugin = {
    install: (app) => {
        app.component(CAvatar.name, CAvatar);
    },
};

export { CAvatar, CAvatarPlugin };
//# sourceMappingURL=index.js.map
